import api from './axios.js';

export const automationsApi = {
  list:             ()            => api.get('/automations'),
  get:              (id)          => api.get(`/automations/${id}`),
  create:           (data)        => api.post('/automations', data),
  update:           (id, data)    => api.put(`/automations/${id}`, data),
  delete:           (id)          => api.delete(`/automations/${id}`),
  publish:          (id)          => api.post(`/automations/${id}/publish`),
  unpublish:        (id)          => api.post(`/automations/${id}/unpublish`),
  testRun:          (id, payload) => api.post(`/automations/${id}/test`, { payload }),
  getExecutions:    (id)          => api.get(`/automations/${id}/executions`),
  cancelExecution:  (id, execId)  => api.delete(`/automations/${id}/executions/${execId}/cancel`),
};
